// extracted by mini-css-extract-plugin
export default {"header":"AddItemModal_header__eZLP3","fields":"AddItemModal_fields__aGZ3+","buttons":"AddItemModal_buttons__0Cm66","placeHolderShimmer":"AddItemModal_placeHolderShimmer__s6HiF"};